import firebase from 'firebase/app';

export const addCustomProspect = async(fbProfile, auth, setDocID, name, setPrevName) => {

return new Promise(async function(resolve, reject) {
    // const msg = '';

    var newDoc = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc()

    await newDoc
    .set({
        CreatedBy: fbProfile.email,
        Company: fbProfile.company,
        Linkedin: '' ,
        ProspectName: name,
        ProspectCompany: '',
        ProspectRole: '',
        ProspectInterest: '',
        ProspectContent: '',
        contactImg: '',
        contactEducation: '',
        contactFieldOfStudy: '',
        contactHeadline: '',
        contactCity: '',
        createdAt: new Date(),
        AuthorID: auth.uid,
        AuthorFirstName: fbProfile.firstName,
        AuthorLastName: fbProfile.lastName,
        MessageApproved: 'No',
        MessageSent: 'No',
        InterestPreAi: '',
        CreatedfromApp: "Yes",
        CreatedfromCext: "No",
        CustomCreated: "Yes"
    }).then(() =>{
        setTimeout(function(){
            setDocID(newDoc.id)
            setPrevName(name)
            // console.log('in adding prospect')
            let newDocId = newDoc.id
            resolve(newDocId)
        }, 10)
    }
        // setShowSpinner(false),
        // saveSearch(fbProfile, auth, profile, LIurl, interests, msg, foundInts, newDoc.id)
    )
    
    });
    
}